import { render, staticRenderFns } from "./newTarget.vue?vue&type=template&id=36ec09b3&scoped=true&"
import script from "./newTarget.vue?vue&type=script&lang=js&"
export * from "./newTarget.vue?vue&type=script&lang=js&"
import style0 from "./newTarget.vue?vue&type=style&index=0&id=36ec09b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec09b3",
  null
  
)

export default component.exports